module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0024.jpg?v=75adc83a";